import { getUserPreferences, updateUserPreferences } from "@/services/api/User";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";

const useUserPreferences = () => {
  const [preferences, setPreferences] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    fetchPreferences();
  }, []);

  const fetchPreferences = async function () {
    try {
      const response = await getUserPreferences();
      setPreferences((response.data.data || []).map((item) => item.uuid));
    } catch (error) {
      console.log("Error", error);
      toast.error("Error to load user preferences!");
    } finally {
      setLoading(false);
    }
  };

  const updatePreferences = async function () {
    setIsUpdating(true);

    try {
      const response = await updateUserPreferences({
        user_preferences: preferences,
      });

      return response.data;
    } catch (error) {
      throw error;
    } finally {
      setIsUpdating(false);
    }
  };

  const toggleUserPreference = function (topicUuid) {
    let selected = [...preferences];
    if (selected.includes(topicUuid)) {
      selected = selected.filter((uuid) => uuid !== topicUuid);
    } else {
      selected.push(topicUuid);
    }

    setPreferences(selected);
  };

  const selectAll = function(topics) {
    let selected = [...preferences];
    topics.forEach((topic) => {
      if (selected.includes(topic.uuid)) return;
      selected.push(topic.uuid);
    });

    setPreferences(selected);
  };

  return {
    fetchPreferences,
    preferences,
    updatePreferences,
    toggleUserPreference,
    isLoading,
    isUpdating,
    selectAll,
  };
};

export { useUserPreferences };
